import { LoadingOutlined } from "@ant-design/icons";

export const ElementLoader = (loading) => {
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
      }}
      spin
    />
  );
  const elementLoading = {
    spinning: loading,
    indicator: antIcon,
  };
  return elementLoading;
};
